export default {
	//url: 'http://192.168.0.11:8067',
	//site: 'http:localhost:3000',
	site: 'https://erp.byteltd.com',
	//url: 'http://10.220.1.27:8067',
	url: 'https://erp.byteltd.com',
};
